import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { StyledHeading, StyledLoginHeader, StyledLoginPage, StyledLogo, StyledLoginContent, ButtonWrapper } from './Login.styled'
import Button from '../Button'

const Login = ({ history }) => {
  const startCourseLink = '/menu'
  return (
    <StyledLoginPage>
      <StyledLoginHeader>
        <StyledLogo src='image/kompetansenorge.png' alt='Kompetanse Norge logo' />
      </StyledLoginHeader>
      <StyledLoginContent>
        <StyledHeading>
          <span className='upper'>
            <FormattedMessage id='login.loginForm.title1' />
          </span>
        </StyledHeading>
        <ButtonWrapper>
          <Link
            to={startCourseLink}
          >
            <Button
              id='login'
              classes='white'
              text='login.loginForm.submitLabel'
            />
          </Link>
        </ButtonWrapper>
      </StyledLoginContent>

    </StyledLoginPage>
  )
}

export default withRouter(Login)
